import styled, {keyframes} from "styled-components";
import {Button} from "../../components/Button";
import {useAppContext} from "../../provider/AppProvider";
import {Leaderbord} from "../../settings/Leaderbord/Leaderbord";
import React from "react";
import {getSizeForLayout} from "../../utils/getSizeForLayout";
import logo_start from '../../assets/logo_new.png';
import {useViewPortState} from "../../provider/ResizeProvider";

const Root = styled.div`
    margin-top: 8px;
    width: 100%;
    padding: 0 16px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    max-height: 75%;
`;

const Controls = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-direction: column;

    @media (min-width: 768px) {
        gap: 24px;
    }

    @media (min-width: 1025px) {
        gap: 24px;
    }
`;

const Logo = styled.img`
    width: 100%;
    max-width: 320px;
    filter: drop-shadow(2px 4px 6px black);
    
    @media (min-width: 768px) {
        max-width: 60%;
    }
    
    @media (min-width: 1025px) {
        max-width: 45%;
    }

    -webkit-user-select: none; /* Safari */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-tap-highlight-color: transparent;

    pointer-events: none; /* Prevent any interactions */
    user-drag: none; /* Disable image dragging */
    -webkit-user-drag: none; /* Disable image dragging for Safari */
`;

const LogoWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

const ControlContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const dropShadowAnimation = keyframes`
    0% {
        filter: drop-shadow(0px 0px 16px gold);
    }
    50% {
        filter: drop-shadow(0px 0px 4px gold);
    }
    100% {
        filter: drop-shadow(0px 0px 16px gold);
    }
`;

const ButtonWrapper = styled.div`
  animation: ${dropShadowAnimation} 2s infinite;
`;

export const StartScreen = () => {
    const {isTableState, isDesktopState} = useViewPortState();
    const {setScreen, showLeaderBoard, translate} = useAppContext();

    return (
        <>
            <Root>
                <LogoWrapper>
                    <Logo src={logo_start} />
                </LogoWrapper>
                <ControlContainer>
                    <Controls>
                        <ButtonWrapper>
                            <Button text={translate.classic} size={getSizeForLayout({m: 60, t: 100, d: 140, isTable: isTableState, isDesktop: isDesktopState})} color='#1c188c' onClick={() => {
                                setScreen('game', 'normal');
                            }}/>
                        </ButtonWrapper>
                        <ButtonWrapper>
                            <Button textColor='#de0707' text={translate.bomb} size={getSizeForLayout({m: 60, t: 100, d: 140, isTable: isTableState, isDesktop: isDesktopState})} color='red' onClick={() => {
                                setScreen('game', 'bomb');
                            }}/>
                        </ButtonWrapper>
                    </Controls>
                </ControlContainer>
            </Root>
            {showLeaderBoard && <Leaderbord isOpen={showLeaderBoard}/>}
        </>
    );
}
